export default "__VITE_ASSET__BJfexG8v__"